import { useContext } from 'react';
import { LanguageContext, type I18nContextValue } from './context';

export function useI18n(): I18nContextValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useI18n must be used within LanguageProvider');
  return ctx;
}
